import { SAVE_ORDER_DETAILS, GET_ORDER_DETAILS } from "../constants";

export const saveOrderDetails = (orderDetails: any) => {
  return {
    type: SAVE_ORDER_DETAILS,
    orderDetails,
  };
};

export const fetchOrderDetails = (orderReference: string) => {
  return {
    type: GET_ORDER_DETAILS,
    orderReference
  };
}
